module.exports = __webpack_public_path__ + "static/media/gpv.d7142055.png";